import { styled, Button } from '@mui/material';
import React from 'react'

export default function ActionButton(props) {
    const { color, children, onClick, ...rest } = props;
    return (
        <Button color={color} onClick={onClick} {...rest}>
            {children}
        </Button>
    )
}
